import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data }) => {
  return (
    <ExcelFile
      element={
        <Button type="primary" style={{ width: "100%", backgroundColor: "green", marginLeft: "5px" }}>
          Excel
        </Button>
      }
    >
      <ExcelSheet data={data} name="Sold Products">
        <ExcelColumn label="Date" value="issue_date" />
        <ExcelColumn label="Invoice No." value="Invoice_no" />
        <ExcelColumn label="Contact" value="Contact" />
        <ExcelColumn
          label="Product"
          value={(col) => {
            const details = col.Details ? col.Details.split("--") : [];
            return details.length > 0 ? details[0] : "";
          }}
        />
        <ExcelColumn label="Category" value="main_category" />
        <ExcelColumn
          label="Size"
          value={(col) => {
            const details = col.Details ? col.Details.split("--") : [];
            const extra = details.length > 1 ? details[1].split("/") : [];
            return extra.length > 0 ? extra[0] : "";
          }}
        />
        <ExcelColumn
          label="Color"
          value={(col) => {
            const details = col.Details ? col.Details.split("--") : [];
            const extra = details.length > 1 ? details[1].split("/") : [];
            return extra.length > 1 ? extra[1] : "";
          }}
        />
        <ExcelColumn label="Quantity" value="quantity" />
        <ExcelColumn label="Price" value="price" />
        <ExcelColumn
          label="Special Discount"
          value={(col) => parseFloat(col.spec_discount || 0)}
        />
        <ExcelColumn
          label="Product Discount"
          value={(col) => parseFloat(col.Discount || 0)}
        />
        {/* <ExcelColumn
          label="Paid Amount"
          value={(col) => {
            const price = parseFloat(col.price || 0);
            const qty = parseFloat(col.quantity || 0);
            const spec = parseFloat(col.spec_discount || 0);
            const disc = parseFloat(col.Discount || 0);
            return price * qty - disc - spec;
          }}
        /> */}
        <ExcelColumn
          label="Total Amount"
          value={(col) => {
            const price = parseFloat(col.price || 0);
            const qty = parseFloat(col.quantity || 0);
            return price * qty;
          }}
        />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
